export const WHITE_LABEL_REQUIRED_MESSAGE =
  "White label is required to create a user";

export function normalizeUserEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function ghostEmailCandidates(email: string): string[] {
  const raw = email.trim();
  const normalized = raw.toLowerCase();
  return raw && raw !== normalized ? [normalized, raw] : [normalized];
}

export function isWhiteLabelRequired(allowUnscoped?: boolean): boolean {
  return !allowUnscoped;
}

export function missingRequiredWhiteLabel(
  whiteLabelId?: string | null,
  allowUnscoped?: boolean
): boolean {
  return isWhiteLabelRequired(allowUnscoped) && !whiteLabelId;
}
